import IcCheckMark from "@/assets/icons/ic-check-mark.svg";

export interface AgentCard {
  id: string;
  taskName: string;
  taskSummary: string;
  matchPercent: number;
  agentName: string;
  agentDescription: string;
  tags: string;
}

export function AgentCardItem({
  agent,
  selected,
  onToggle,
}: {
  agent: AgentCard;
  selected: boolean;
  onToggle: () => void;
}) {
  return (
    <div className="flex gap-4 md:gap-6 items-center">
      <div className="flex items-center">
        <button
          type="button"
          onClick={onToggle}
          className={`w-5 h-5 rounded border cursor-pointer flex items-center justify-center ${
            selected ? "bg-[#000000] border-[#000000]" : "bg-white border-[rgba(0,0,0,0.15)]"
          }`}
        >
          {selected && <img src={IcCheckMark} alt="checked" />}
        </button>
      </div>
      <div className="flex-1 flex flex-col md:flex-row border rounded overflow-hidden md:p-5 p-3">
        {/* <div className="flex flex-col items-center md:items-start gap-2 md:gap-3 p-3 md:p-2 md:w-[160px] shrink-0 bg-[#F9F9F9] rounded-t-xl md:rounded-l-xl md:rounded-tr-none h-fit">
          <span className="inline-flex items-center self-start px-3 py-1 bg-black/4 rounded text-sm font-bold text-[#8D8D8D] bg-black/[0.04]">
            {agent.taskName}업무
          </span>
          <span className="text-xs text-[#000000]">{agent.taskSummary}</span>
        </div>
        <div className="hidden md:flex items-center justify-center mx-6  w-[28px] shrink-0">
          <img src={IcLine} alt="Line Icon" />
        </div> */}
        <div className="flex-1 flex flex-col gap-3 bg-white md:rounded-none md:flex-row md:items-center md:gap-8">
          <div className="flex flex-row md:flex-col gap-3 md:w-[232px] break-all justify-between">
            <div className="md:hidden block text-lg font-bold text-[#000000] w-[173px]">
              {agent.agentName}
            </div>
            <span className="inline-flex shrink-0 self-start items-center px-2 rounded-[4px] bg-[#FFAA72] text-sm font-medium text-black h-6">
              매칭 {agent.matchPercent}%
            </span>
            <span className="text-lg font-bold text-[#000000] hidden md:block">
              {agent.agentName}
            </span>
          </div>
          <div className="border-t md:border-t-0 border-[rgba(0,0,0,0.15)] pt-3 md:pt-0" />
          <div className="flex-1 flex flex-col gap-4 md:px-3">
            <p className="text-sm leading-[20px] tracking-[-0.01em] text-[#000000]">
              {agent.agentDescription}
            </p>
            {/* <div className="flex flex-wrap gap-2">
              {agent.tags.map((tag, i) => (
                <span
                  key={i}
                  className="px-2 py-0.5 text-xs leading-4 font-normal text-[#000000] bg-[#EBEBEB] rounded-[4px]"
                >
                  {tag}
                </span>
              ))}
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
